const DOCUMENT = 'BLOCKED_TALENTS_';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  LOAD_FORM_DATA: DOCUMENT + 'LOAD_FORM_DATA',
  LOAD_FORM_DATA_SUCCESS: DOCUMENT + 'LOAD_FORM_DATA_SUCCESS',
  SHOW_MODAL: DOCUMENT + 'SHOW_MODAL',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_SUCCESS: DOCUMENT + 'SAVE_SUCCESS',
  CANCEL: DOCUMENT + 'CANCEL',
  FILTER_TALENTS: DOCUMENT + 'FILTER_TALENTS',
  CHANGE_SELECTED_TALENTS: DOCUMENT + 'CHANGE_SELECTED_TALENTS',
  UNBLOCK_TALENT: DOCUMENT + 'UNBLOCK_TALENT',
  UNBLOCK_TALENT_SUCCESS: DOCUMENT + 'UNBLOCK_TALENT_SUCCESS',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  loadFormData: data => {
    return {
      type: actions.LOAD_FORM_DATA,
      payload: data,
    };
  },

  loadFormDataSuccess: data => {
    return {
      type: actions.LOAD_FORM_DATA_SUCCESS,
      payload: data,
    };
  },

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  showModal: data => ({
    type: actions.SHOW_MODAL,
    payload: data,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveSuccess: data => ({
    type: actions.SAVE_SUCCESS,
    payload: data,
  }),

  cancel: () => ({
    type: actions.CANCEL,
  }),

  filterTalents: data => {
    return {
      type: actions.FILTER_TALENTS,
      payload: data,
    };
  },

  changeSelectedTalents: data => {
    return {
      type: actions.CHANGE_SELECTED_TALENTS,
      payload: data,
    };
  },

  unblockTalent: data => {
    return {
      type: actions.UNBLOCK_TALENT,
      payload: data,
    };
  },

  unblockTalentSuccess: data => {
    return {
      type: actions.UNBLOCK_TALENT_SUCCESS,
      payload: data,
    };
  },
};

export default actions;
